import cx from 'classnames'
import Button from 'components/Button'
import ModalDialog from 'components/ModalDialog'
import styles from './modalDeleteProcess.module.scss'

interface IModalConfirmProps {
  isOpen: boolean
  toggle: () => void
  onAccept: () => Promise<void>
  onCancel?: () => void
  title: string
  content: string
  confirmAction: string
  isDelete?: boolean
  isLoading?: boolean
}

const ModalConfirm = ({
  isOpen,
  toggle,
  onAccept,
  onCancel,
  title,
  content,
  confirmAction,
  isDelete,
  isLoading = false
}: IModalConfirmProps) => {
  return (
    <ModalDialog isOpen={isOpen} headless className={styles.deleteDialog}>
      <h5 className={styles.title}>{title}</h5>
      <p className={styles.deleteTitle}>{content}</p>
      <div className={styles.actionButtons}>
        <Button outline onClick={onCancel ? onCancel : toggle} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          className={cx({ [styles.deleteButton]: isDelete, [styles.primaryColor]: !isDelete })}
          color="danger"
          onClick={onAccept}
          disabled={isLoading}
          isLoading={isLoading}
        >
          {confirmAction}
        </Button>
      </div>
    </ModalDialog>
  )
}

export default ModalConfirm
